import React from "react";
import { Card, Statistic } from "antd";

import { Area } from "@ant-design/plots";
import numeral from "numeral";

import CountUp from "react-countup";

import "./CardTotal.css";

import data from "./data";

const formatter = (value) => <CountUp end={value} separator="," />;

function CardTotal(props) {
  const config = {
    data: props.ticketsByDay,
    xField: "Date",
    yField: "Total",
    xAxis: {
      range: [0, 1],
    },
  };

  return (
    <Card title={props.title} bordered={true}>
      <div className="card-card">
        {props.amount ? (
          <div className="sales">
            <div className="salesClientes">
              <Statistic
                title="Clientes"
                value={props.tickets}
                formatter={formatter}
              />
            </div>
            <div className="salesAmount">
              <Statistic
                title="Ventas de hoy"
                value={props.amount}
                formatter={formatter}
              />
              {/* {numeral(props.amount).format("$0,00")} */}
            </div>
          </div>
        ) : (
          "No Data"
        )}
        <div className="area">
          <Area
            width={380}
            height={100}
            animation={true}
            autoFit={true}
            padding="auto"
            //Remove horizontal lines from graph
            yAxis={false}
            smooth={true}
            {...config}
          />
        </div>
      </div>
    </Card>
  );
}

export default CardTotal;
